module.exports = __webpack_public_path__ + "img/w5.f35a7cf0.jpg";